export const allCoordinates = {
  rental: [
    [8.190613148384728, 5.730828902655048],
    [16.633628039620817, 11.069794201524928],
    [25.09226018190384, 16.418635115027428],
    [33.54612335965794, 21.764460359783698],
    [41.98882119823247, 27.103225169470534],
    [50.44516383076552, 32.45061830474879],
    [58.89367067615967, 37.79305645698332],
    [67.35258487612009, 43.142075730487704],
    [69.5, 51.951909933122806],
    [69.5, 61.954796134334174],
    [69.5, 71.9626150727272],
    [69.5, 81.95591753721237],
    [75.17686157292519, 89.02018990767465],
    [83.34327848682005, 94.80341122412938],
    [91.49864260278446, 100.57880526734152],
    [99.66812704932818, 106.36419892209233],
    [107.81495960816937, 112.13355116220555],
    [115.98227361578029, 117.91740777459927],
    [124.13530758705747, 123.69115167643758],
    [132.30307199666345, 129.47532725055544],
    [140.46837300925108, 135.2577583178354],
    [148.62865446545698, 141.03663467981778],
    [156.78944444378612, 146.81587116252558],
    [164.94979672109184, 152.59479767797166],
    [173.10966442750941, 158.37338103426737],
    [181.26678745250683, 164.15002068621106],
    [189.43179197572135, 169.93224178825403],
    [197.58441389352083, 175.705693885684],
    [207.49375788892212, 176],
    [217.50615403630945, 176],
    [227.49176042379986, 176],
    [237.4993851956915, 176],
    [247.49585879090773, 176],
    [257.50249274037446, 176],
    [267.4979901313782, 176],
    [277.4965948920942, 176],
    [287.50025675112556, 176],
    [297.49781802919347, 176],
    [307.49814433218876, 176],
    [317.4936269431764, 176],
    [327.4928909400478, 176],
    [337.5024487092287, 176],
    [347.49317425489426, 176],
  ],
  gig: [
    [2.7149177715182304, 2.5844332966953516],
    [11.180287063121796, 7.937534466385841],
    [19.626254959963262, 13.278367107035592],
    [28.070788085460663, 18.618292465806007],
    [36.5310337945848, 23.96815372304627],
    [44.97790607530624, 29.309558253502473],
    [53.4314067010564, 34.655154237432725],
    [61.883317845873535, 39.99974510842003],
    [69, 46.08377856016159],
    [69, 56.07568434625864],
    [69, 66.08193740552815],
    [69, 76.08393143657304],
    [69, 86.08023071289062],
    [74.94803054482327, 92.85772266764252],
    [83.33955966140275, 98.30022869468121],
    [91.7211826743769, 103.73630990595302],
    [100.11002208324862, 109.17707146542125],
    [108.50527023272343, 114.62198955093777],
    [116.8918198454835, 120.06126601407072],
    [125.27405898922007, 125.4977468301513],
    [133.66633789241314, 130.9407391473651],
    [142.05932237485422, 136.38418908311974],
    [150.44808479146377, 141.8249007076065],
    [158.83892469705097, 147.26695973208734],
    [167.2265375464408, 152.70692578012017],
    [175.61991335227867, 158.1506295170493],
    [184.0197631213814, 163.59853208158165],
    [192.39647438999464, 169.03142767579652],
    [200.7977174949192, 174.4802339181333],
    [209.1771198865049, 179.9148748978189],
    [217.5638053061848, 185.35423944143986],
    [225.96171846069547, 190.80088597307963],
    [234.35763057845543, 196.24623468945538],
    [242.74097318388522, 201.6834311792627],
    [252.4903435101296, 202.5],
    [262.5073719546199, 202.5],
    [272.5004787513026, 202.5],
    [282.50805688647415, 202.5],
    [292.4960054514322, 202.5],
    [302.5046038733253, 202.5],
    [312.4906211072812, 202.5],
    [322.5033461107048, 202.5],
    [332.5006712071936, 202.5],
    [342.50928804154137, 202.5],
    [352.50937862414867, 202.5],
    [362.49350137902366, 202.5],
    [372.4919153963983, 202.5],
    [382.49692106714065, 202.5],
    [392.49321991205215, 202.5],
  ],
  ecommerce: [
    [3.016655986197293, 2.275238344212994],
    [11.475976049900055, 7.624514266848564],
    [19.919204216566868, 12.963614431064343],
    [28.364266477525234, 18.30387439019978],
    [36.81710120558273, 23.64904929176555],
    [45.27657160144008, 28.99842027738123],
    [53.728882430135855, 34.34326388964473],
    [62.18426442646887, 39.69004956379649],
    [69, 45.92486877646297],
    [69, 55.92837583796063],
    [69, 65.93398625131522],
    [69, 75.93825951304461],
    [69, 85.93393983691931],
    [69.3698616027832, 95.73440790176392],
    [77.81557461780903, 101.08706373804125],
    [86.2539161072782, 106.43504770834079],
    [94.71129637956619, 111.79509792476892],
    [103.14931301954311, 117.14287601457886],
    [111.60089562212124, 122.49925183068649],
    [120.04343273234372, 127.84989486764766],
    [128.49493651131343, 133.20622072756487],
    [136.94440115522593, 138.5612542409217],
    [145.37646137862066, 143.9052573210995],
    [153.83801643108563, 149.267953396017],
    [162.2707861543604, 154.61240613730297],
    [170.72638629000903, 159.97132815309783],
    [179.1702573380078, 165.3228166023777],
    [187.6120400463169, 170.67298152058243],
    [196.062455826288, 176.02861783727462],
    [204.51020023191813, 181.38256111189548],
    [212.95124523986306, 186.73225849631672],
    [221.39599391072989, 192.0843031583354],
    [229.8448752149834, 197.4389669673908],
    [238.30285210978582, 202.79939530642127],
    [246.73513931934758, 208.1435422440602],
    [255.1812858581543, 213.49647283554077],
    [263.6332252581924, 218.85307477986316],
    [272.0842527549685, 224.20909878549537],
    [280.534033737189, 229.56433278519216],
    [288.9690327683202, 234.91019839922046],
    [297.5009912633104, 240],
    [307.4931967615703, 240],
    [317.4929569837259, 240],
    [327.5012375505612, 240],
    [337.50445338645113, 240],
    [347.506804492843, 240],
    [357.509392940221, 240],
    [367.4991635224044, 240],
    [377.5096432324153, 240],
    [387.5048412955057, 240],
    [397.49022611172404, 240],
    [407.50222259150746, 240],
    [417.49599464877974, 240],
    [427.4953252949581, 240],
    [437.50872124452144, 240],
    [447.49312859773636, 240],
  ],
  nexus: [
    [5.305291973054409, 3.7224640417844057],
    [13.77032115322072, 9.07535014100722],
    [22.21264576597605, 14.41387894024956],
    [30.66505688925099, 19.758785974085185],
    [39.12473625410348, 25.108289101859555],
    [47.57771002501249, 30.45355192758143],
    [56.029605827410705, 35.798133096745005],
    [64.47246086003724, 41.136997308552964],
    [69, 48.64764029055368],
    [69, 58.642017880032654],
    [69, 68.63790213175525],
    [69, 78.65562481433153],
    [69, 88.65574853867292],
    [69, 98.65226623322815],
    [75.8817431361822, 104.8476716564328],
    [84.33692617304041, 110.18939379163203],
    [92.7965772797179, 115.53393871462322],
    [101.24957548259408, 120.874280539545],
    [109.70487461196035, 126.2160760183865],
    [118.16301565191316, 131.55966692810398],
    [126.60482884861631, 136.89294241338575],
    [135.0624197517286, 142.23618576372746],
    [143.526939975392, 147.5838068436592],
    [151.9683802144973, 152.91684670590985],
    [160.43182597438084, 158.2637889729843],
    [168.88102875478262, 163.60173296782295],
    [177.33517233172824, 168.94279840452145],
    [185.7955093626365, 174.2877766731458],
    [194.2546838277699, 179.6320204688077],
    [202.70779012097455, 184.97243058184313],
    [211.15147933922708, 190.3068912792951],
    [219.60837403407277, 195.64969478686908],
    [228.06263287916414, 200.99083304640334],
    [236.52226543426514, 206.33536624908447],
    [244.967949762653, 211.6710873951779],
    [253.42605671357524, 217.0146567685042],
    [261.8803600705937, 222.35582314929206],
    [270.3314152817379, 227.6949374523615],
    [278.7913784541465, 233.03967952879293],
    [287.2448368355847, 238.38031208024307],
    [295.6968797589375, 243.72005038922043],
    [304.1552803989325, 249.0638053061848],
    [312.60455030727235, 254.40179171037062],
    [321.05206055915914, 259.73866641824134],
    [329.51474956299853, 265.08513059034203],
    [337.97159608794027, 270.42790366566624],
    [346.5009912633104, 275.5],
    [356.4931967615703, 275.5],
    [366.4929569837259, 275.5],
    [376.5012375505612, 275.5],
    [386.50445338645113, 275.5],
    [396.506804492843, 275.5],
    [406.509392940221, 275.5],
    [416.4991635224044, 275.5],
    [426.5096432324153, 275.5],
    [436.5048412955057, 275.5],
    [446.49022611172404, 275.5],
    [456.50222259150746, 275.5],
    [466.49599464877974, 275.5],
    [476.4953252949581, 275.5],
    [486.50872124452144, 275.5],
    [496.49312859773636, 275.5],
  ],
  facebook: [
    [3.4083159640431404, 3.2817261289171875],
    [7.480746352463029, 6.182269157670794],
    [11.565297196662868, 9.091444845589754],
    [15.634767679637662, 11.989879714771389],
    [19.70363210116375, 14.887882923459808],
    [23.775128928105914, 17.78776103348483],
    [27.849731733091176, 20.689851341657178],
    [31.92387852389038, 23.591616858822128],
    [35.99335224535025, 26.490054034578566],
    [40.0688952603432, 29.39281399682065],
    [44.14640665559091, 32.29697591589965],
    [48.21456346541004, 35.194475136058394],
    [52.279887001263205, 38.08995638850088],
    [56.35319003369659, 40.99112094820003],
    [60.4342925693752, 43.89784061691466],
    [64.4958638888686, 46.79064939519144],
    [68.56939052035091, 49.69197321081412],
    [72.6444323681742, 52.5943762223409],
    [76.72572590793425, 55.501231931577784],
    [80.78894533982452, 58.39521455948916],
    [84.86910684669397, 61.301263990951846],
    [88.94218572324348, 64.20226889812797],
    [93.01357481819286, 67.10207027724519],
    [97.08822566910362, 70.00419480559098],
    [101.15590119139233, 72.9013512340853],
    [105.22016064694617, 75.79607460722724],
    [109.29724499745248, 78.69993236846203],
    [113.37316558517045, 81.6029612526576],
    [117.44616681034472, 84.50391085350955],
    [121.51183504531764, 87.39963761404758],
    [125.58784757697299, 90.30273198428493],
    [129.65993181234785, 93.20302846940098],
    [133.74339657039855, 96.11143060459882],
    [137.8068264960341, 99.00556315432769],
    [141.88187327142805, 101.90796967546159],
    [145.9568262429002, 104.81030938580061],
    [150.02871624554973, 107.71046753082886],
    [154.10087488323916, 110.61081700816192],
    [158.16983600397907, 113.50888908978465],
    [162.23801469802856, 116.40640389674186],
    [162.5, 121.28144058923425],
    [162.5, 126.27426549734734],
    [162.5, 131.28097730558434],
    [162.5, 136.28155547413112],
    [162.5, 141.28169127726065],
    [162.5, 146.27955434044193],
    [162.5, 151.28320148259007],
    [162.5, 156.2764175649565],
    [162.5, 161.28161229717728],
    [166.27620458602905, 164.35421473908423],
    [170.31817109975964, 167.3097583963028],
    [174.35422654356807, 170.26097979475045],
    [178.39181296911556, 173.21332066891688],
    [182.42002831492573, 176.15880927570677],
    [186.4584629163146, 179.11177034816518],
    [190.49489974975586, 182.0632706241608],
  ],
  airbnb: [
    [2.485819026566045, 2.614385794131535],
    [6.560588976949453, 5.519342967563868],
    [10.627886625888937, 8.418973038866291],
    [14.70272881482231, 11.323981712112472],
    [18.782218986089806, 14.232303993191218],
    [22.844487900632114, 17.128349013499786],
    [26.923537407340586, 20.036357139009652],
    [30.984121051517008, 22.93120070787478],
    [35.055302811097704, 25.833599812817635],
    [39.13056584009489, 28.738908508488908],
    [43.201056664347064, 31.64081503653456],
    [47.276121619156505, 34.54598252250822],
    [51.346500095848505, 37.44780895649829],
    [55.41813606709241, 40.35053187491905],
    [59.48730743681165, 43.25149774644735],
    [63.56440835300482, 46.158116696110625],
    [67.63595932494891, 49.06077901741085],
    [71.70154271777432, 51.959186972948146],
    [75.77360488830934, 54.86221373445774],
    [79.83926972195616, 57.7606797502294],
    [83.91012079853442, 60.662843106903814],
    [87.984032410159, 63.567188359328334],
    [92.05731287983488, 66.47108366234374],
    [96.1242294211136, 69.37044203697458],
    [100.19933077282312, 72.27563547077774],
    [104.2690228806817, 75.17697258338515],
    [108.34709757014733, 78.0842857488416],
    [112.41577103551587, 80.98489665779954],
    [116.4853637195751, 83.88616288987069],
    [120.56043859135303, 86.79133744578182],
    [124.62371916473866, 89.68810369100608],
    [128.6949956129851, 92.59057030074605],
    [132.76781572479084, 95.49413740857169],
    [136.83663498185163, 98.39485225434753],
    [138.501, 102.5514181154708],
    [138.501, 107.5488690020815],
    [138.501, 112.53706447828375],
    [138.501, 117.54465585976288],
    [138.501, 122.54310318328255],
    [138.501, 127.53712512379302],
    [138.501, 132.55223249434889],
    [138.501, 137.55065624999997],
    [138.501, 142.54626295711833],
    [140.92043176368648, 146.30454637811192],
    [144.98157029111752, 149.19592755547492],
    [149.06119025150747, 152.10046683296846],
    [153.1409368143082, 155.00509624671938],
    [157.204453523563, 157.89817060202125],
    [161.28361950088873, 160.80238666028018],
    [165.3605175257453, 163.70498801984405],
    [169.4338404264592, 166.60504402258667],
    [173.4936248693466, 169.4954611415863],
  ],
  maps: [
    [4.70942734868275, 4.023911737154331],
    [13.251771028512117, 9.205304020247901],
    [21.80777364031123, 14.394981182451454],
    [30.36012580737261, 19.582444152987843],
    [31.500075216677995, 28.948112268580445],
    [31.500046669673647, 38.93962088349846],
    [31.500018109245598, 48.93582782209813],
    [34.48085776122578, 57.40885359667907],
    [42.61067073016379, 63.231052730606166],
    [50.74343059861512, 69.05536229879047],
    [58.87776416812625, 74.88079887948814],
    [66.99343362951278, 80.69286908206941],
  ],
  googleAds: [
    [38.29489067068789, 1.8138400665484369],
    [34.1467399597168, 4.6151885986328125],
    [30.007847103639506, 7.410285072866827],
    [25.8586083145492, 10.212368410953786],
    [21.715048186481, 13.010616809129715],
    [17.578852484351955, 15.803891828749329],
    [13.433394845356815, 18.603421662875917],
    [9.282860481063835, 21.40637993486598],
    [5.138448009616695, 24.205203941557556],
    [1.0070128440856934, 26.995264053344727],

    [2.124229421113597, 30.37044203697458],
    [6.199330772823117, 33.27563547077774],
    [10.269022880681703, 36.17697258338515],
    [14.347097570147326, 39.084285748841594],
    [18.415771035515874, 41.98489665779954],
    [22.485363719575105, 44.88616288987069],
    [26.560438591353034, 47.79133744578182],
    [30.62371916473866, 50.68810369100608],
    [34.69499561298511, 53.59057030074605],
    [38.767815724790836, 56.49413740857169],
    [42.83663498185163, 59.394852254347526],
    [44.501000000000005, 63.551418115470796],
    [44.501000000000005, 68.5488690020815],
    [44.501000000000005, 73.53706447828375],
    [44.501000000000005, 78.54465585976288],
    [44.501000000000005, 83.54310318328255],
    [44.501000000000005, 88.53712512379302],
    [44.501000000000005, 93.55223249434889],
    [44.501000000000005, 98.55065624999997],
    [44.501000000000005, 103.54626295711833],
    [46.92043176368648, 107.30454637811192],
    [50.98157029111752, 110.19592755547492],
    [55.06119025150747, 113.10046683296846],
    [59.14093681430819, 116.00509624671938],
    [63.20445352356299, 118.89817060202125],
    [67.28361950088873, 121.80238666028018],
    [71.36051752574531, 124.70498801984405],
    [75.4338404264592, 127.60504402258667],
    [79.4936248693466, 130.4954611415863],
  ],
  linkedin: [
    [22.019286352504423, 25.46215455262427],
    [26.213849364226917, 22.760571595921647],
    [30.424377515028027, 20.048706007270084],
    [34.63628387451172, 17.335952758789062],
    [38.824655474862084, 14.638357490766793],
    [43.033684353373246, 11.927457535115536],
    [47.23421462927945, 9.22203125571832],
    [51.43666255372227, 6.515369880653452],
    [55.64961605248391, 3.8019422034849413],
    [59.85104687511921, 1.0959359109401703],
    [62.013574818192865, 6.10207027724519],
    [66.08822566910362, 9.004194805590984],
    [70.15590119139233, 11.901351234085297],
    [74.22016064694617, 14.79607460722724],
    [78.29724499745248, 17.69993236846203],
    [82.37316558517045, 20.602961252657593],
    [86.44616681034472, 23.503910853509552],
    [90.51183504531764, 26.399637614047577],
    [94.58784757697299, 29.302731984284932],
    [98.65993181234785, 32.20302846940098],
    [102.74339657039855, 35.11143060459882],
    [106.80682649603409, 38.00556315432769],
    [110.88187327142805, 40.90796967546159],
    [114.9568262429002, 43.81030938580061],
    [119.02871624554973, 46.710467530828865],
    [123.10087488323916, 49.610817008161916],
    [127.16983600397907, 52.508889089784645],
    [131.23801469802856, 55.406403896741864],
    [131.5, 60.28144058923425],
    [131.5, 65.27426549734734],
    [131.5, 70.28097730558434],
    [131.5, 75.28155547413112],
    [131.5, 80.28169127726065],
    [131.5, 85.27955434044193],
    [131.5, 90.28320148259007],
    [131.5, 95.27641756495649],
    [131.5, 100.28161229717728],
    [135.27620458602905, 103.35421473908423],
    [139.31817109975964, 106.30975839630281],
    [143.35422654356807, 109.26097979475045],
    [147.39181296911556, 112.21332066891688],
    [151.42002831492573, 115.15880927570677],
    [155.4584629163146, 118.11177034816518],
    [159.49489974975586, 121.0632706241608],
  ],
  internal: [
    [1.0028915852308273, 172.99803417921066],
    [9.273922884836793, 167.37504056841135],
    [17.539011333782128, 161.75608715648013],
    [25.80612361198655, 156.13575786062574],
    [34.075331687927246, 150.5140037536621],
    [42.35311333811842, 144.88642097171396],
    [50.62625913425245, 139.26198983758331],
    [58.88468039245345, 133.64756906125695],
    [67.16294591791802, 128.0196573206249],
    [75.43332191027412, 122.39710921514961],
    [83.69940238952773, 116.7774813794515],
    [91.97020037215935, 111.15464638730668],
    [100.24347822966092, 105.53012547232538],
    [108.5011154783765, 99.91623769849502],
    [116.77547900940971, 94.2909786971602],
    [125.04487579720808, 88.66909629596921],
    [133.31205395941333, 83.0487222094107],
    [141.58018446625056, 77.42770067907077],
    [149.86295252883792, 71.7967279250588],
    [158.12610801137998, 66.17908862467448],
    [166.40023709996603, 60.553989007137716],
    [174.6650452478948, 54.935226155581404],
    [182.93637125878013, 49.31203218770679],
    [191.20675377903382, 43.689479644293215],
    [199.47258857708994, 38.070018832966525],
    [207.7430744364392, 32.447396035306156],
    [216.02070659293895, 26.81991488543281],
    [224.28043121327983, 21.204608028916482],
    [232.55212671496474, 15.581162865715669],
    [240.82016175322133, 9.960206238916726],
    [249.10189998979695, 4.329933603774407],
  ],
}
